import {
  isQuotingToolAvailable,
  hasAccessToContacts,
} from 'modules/common/permissions';

import { initAccountDetailsPage } from './accountDetailsPage/data/sagas';
import AccountDetailsPage from './accountDetailsPage/entry';
import { initContactDetailsPage } from './contactDetailsPage/data/sagas';
import ContactDetailsPage from './contactDetailsPage/entry';
import { initSearchPage } from './searchPage/data/sagas';
import SearchPage from './searchPage/entry';

export default [
  {
    component: AccountDetailsPage,
    exact: true,
    path: '/accounts/:accountId',
    permissions: [isQuotingToolAvailable, hasAccessToContacts],
    saga: initAccountDetailsPage,
  },
  {
    component: ContactDetailsPage,
    exact: true,
    path: '/contacts/:contactId',
    permissions: [isQuotingToolAvailable, hasAccessToContacts],
    saga: initContactDetailsPage,
  },
  {
    component: SearchPage,
    exact: true,
    path: '/contacts',
    permissions: [isQuotingToolAvailable, hasAccessToContacts],
    saga: initSearchPage,
  },
];
